import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { CascadingSchemePayload, CascadingSchemeResponse } from "@/types/interface/cascading-scheme";

export const useCascadingSchemeStore = defineStore("cascadingSchemeStore", () => {
  const scheme = ref<CascadingSchemeResponse>();
  const schemes = ref<CascadingSchemeResponse[]>([]);

  function initSchemes(data: any) {
    schemes.value = data?.data;
  }

  function addNewScheme(data: any) {
    scheme.value = data;
  }

  async function dispatchGetList(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.cascadingScheme.getCascadingScheme(page, limit, queryParam);
      if (status === 200 ) {
        initSchemes(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idItem = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.cascadingScheme.findCascadingScheme(idItem);
      if (status === 200 ) {
        addNewScheme(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: CascadingSchemePayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.cascadingScheme.createCascadingScheme(payload);
      if (status === 200 ) {
        addNewScheme(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idItem = "", payload: CascadingSchemePayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.cascadingScheme.updateCascadingScheme(idItem, payload);
      if (status === 200 ) {
        addNewScheme(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idItem = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.cascadingScheme.deleteCascadingScheme(idItem);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    scheme,
    schemes,
    initSchemes,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetList,
    dispatchDelete
  };
});